module.exports = __webpack_public_path__ + "img/bar-chart-circle-02.02ab473c.svg";